<template>
  <div class="table-responsive" style="overflow: hidden;">
    <div class=" table mb-0 col-xs-12 p-0">
      <table class="w-100">
        <tbody>
          <tr>
            <td
              class="d-flex align-items-center p-0 mb-2"
              style=";border: none !important;"
            >
              <p
                class="mb-0 col-md-7 pl-0 pr-2 text-nowrap"
                style="color: #fc6075;"
                title="Talent Search - HR Management"
              >
                Application Mgt - Scheduling Interview
              </p>
              <strong
                class="col-md-5 pr-0 pl-2 text-nowrap"
                title="Completed in 3 Years"
                >Active</strong
              >
            </td>
          </tr>
          <tr>
            <td
              class="d-flex align-items-center p-0 mb-2"
              style=";border: none !important;"
            >
              <p
                class="mb-0 col-md-7 pl-0 pr-2 text-nowrap"
                style="color: #fc6075;"
                title="Set Search Criteria Stage"
              >
                3: Scheduling Interview
              </p>
              <strong class="col-md-7 pr-0 pl-2">{{app.status > 3 ? 'Completed' : (app.status == 3) ?'Active' : 'Inactive'}}</strong>
            </td>
          </tr><tr>
                <td class="d-flex align-items-center p-0 mb-2 mt-3">
                  <p class="mb-0 col-md-7 pl-0 pr-2"><i class="la la-check"></i> Proposed Interview Date</p>
                  <div class="col-md-5 pr-0 pl-2 custom-control">
                  <input
                    type="date"
                    class="form-control"
                    :readonly="app.applicationInterviewScheduling.status == 1"
                    v-model="proposedDate"
                  />
                  </div>
                </td>
              </tr>
              <tr>
                <td class="align-items-center p-0 mb-2" v-if="changeTime">
                  <p class="mb-0">Proposed Interview time</p>
                  <div class="row" style="margin-left: 0; margin-right: 0;">
                    <button type="button" class="btn btn-primary btn-sm" style="margin: 2px" v-for="item in times" :key="item" @click="chooseTime(item)">{{item}}</button>
                  </div>
                </td>
                <td class="d-flex align-items-center p-0 mb-2" v-else>
                  <p class="mb-0 col-md-7 pl-0 pr-2"><i class="pr-3"></i>Proposed Interview time</p>
                  <div class="col-md-5 pr-0 pl-2 custom-control">
                    <span>{{app.applicationInterviewScheduling.proposedTime}}</span>
                  </div>
                </td>
              </tr>
              <tr v-if="app.applicationInterviewScheduling.confirmedDate">
                <td class="d-flex align-items-center p-0 mb-2 mt-3">
                  <p class="mb-0 col-md-7 pl-0 pr-2"><i class="la la-check"></i> Confirmed Interview Date</p>
                  <div class="col-md-5 pr-0 pl-2 custom-control">
                  <input
                    type="date"
                    class="form-control"
                    :readonly="true"
                    v-model="app.applicationInterviewScheduling.confirmedDate"
                  />
                  </div>
                </td>
              </tr>
              <tr v-if="app.applicationInterviewScheduling.confirmedDate">
                <td class="d-flex align-items-center p-0 mb-2">
                  <p class="mb-0 col-md-7 pl-0 pr-2"><i class="pr-3"></i>Confirmed Interview time</p>
                  <div class="col-md-5 pr-0 pl-2 custom-control">
                    <span>{{app.applicationInterviewScheduling.confirmedTime}}</span>
                  </div>
                </td>
              </tr>
              <tr v-if="app.applicationInterviewScheduling.proposedTime || interviewers.length > 0">
            <td
              class="d-flex align-items-center p-0 mb-2"
              style=";border: none !important;"
            >
              <p
                class="mb-0 col-md-7 pl-0 pr-2 text-nowrap"
                title="Set Search Criteria Stage"
              >
                Interviewers
              </p>
            </td>

          </tr>
          <tr v-if="app.applicationInterviewScheduling.proposedTime && app.status == 3">
                <td class="d-flex align-items-center p-0">
                  <div class="mb-0 col-md-8 pl-0 pr-2">
                    <div class="form-group">
                    <label>Add Interviewer <span class="text-danger">*</span></label>
                    <select class="form-control" v-model="employeeId">
                      <option selected>Select Staff</option>
                      <option
                        v-for="member in employees"
                        :key="member.id"
                        :value="member.id"
                      >
                        {{ member.lastName + " " + member.firstName }}
                      </option>
                    </select>
                  </div>
                  </div>
                  <div class="col-md-4 pr-0 pl-2 custom-control">
                  <button type="button" class="btn btn-primary btn-sm" style="margin: 2px" @click="add(employeeId)"> Add </button>
                  </div>
                </td>
              </tr>
              <tr v-for="item in interviewers" :key="item.id">
                <td class="d-flex align-items-center p-2">
                  <div class="mb-0 col-md-10 pl-0 pr-2">
                    <span>{{item.employee.firstName + ' ' + item.employee.lastName}}</span>
                  </div>
                  <div class="col-md-2 pr-0 pl-2 custom-control">
                  <i class="la la-times" v-if="app.status == 3" @click="remove(item.id)"></i>
                  </div>
                </td>
              </tr>
              <tr v-if="app.applicationInterviewScheduling.proposedTime && !app.applicationInterviewScheduling.status">
                <td class="align-items-center p-0 mb-2">
                  <p class="mb-2 mt-3">Candidate Invitation Message</p>
                  <div class="custom-control mb-3 pl-0">
                  <quill-editor
                    v-model="app.applicationInterviewScheduling.customMessage"
                    ref="myQuillEditor"
                    :options="editorOption"
                      >
                  </quill-editor></div>
                </td>
              </tr>
        </tbody>
      </table>
    </div>
    <button v-if="(app.status == 3 && app.applicationInterviewScheduling.status == 0 && app.applicationInterviewScheduling.proposedTime)" type="button" class="btn btn-primary btn-lg btn-block mt-5" style="border-radius: 0" @click="action">Send Invite <i class="la la-angle-right ml-2"></i></button>
  </div>
</template>

<script>
import { jobService } from '@/services/jobService';
import { employeeService } from "@/services/employeeService";
export default {
  name: "applications-timeline-four",
  props: {
    action: { type: Function },
    add: { type: Function },
    remove: { type: Function },
    app: {},
    interviewers: [],
    currentOffice: {}
  },
  data() {
    return {
      times: [],
      changeTime: false,
      coverLetterAvailable: true,
      cvAvailable: true,
      referralAvailable: true,
      proposedDate: this.app.applicationInterviewScheduling.proposedDate,
      employees: [],
      employeeId: null,
      editorOption: {
        theme: 'snow',
    boundary: document.body,
    modules: {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'font': [] }],
        [{ 'align': [] }]
      ]
    },
    placeholder: 'Insert text here ...',
    readOnly: false
      },
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  watch: {
    proposedDate: function(newVal, oldVal) {
      if(newVal != oldVal){
        this.app.applicationInterviewScheduling.proposedDate = newVal
        this.getApplicationTime();
        this.changeTime = true
      }
    }
  },
  mounted() {
    this.getEmployees()
  },
  methods: {
    getApplicationTime(){
      jobService.getApplicationInterviewTime(this.app.id, this.app.applicationInterviewScheduling.proposedDate)
        .then(
          m => {
            this.times = m
          }
        )
    },
    getEmployees() {
      employeeService.getEmployees(this.currentOffice.id).then(
        (model) => {
          this.employees = model;
          // console.log(model);
        },
        (error) => {
          error = error;
        }
      );
    },
    chooseTime(time){
      this.app.applicationInterviewScheduling.proposedTime = time
      this.changeTime = false
    },
    onEditorChange({ quill, html, text }) {
      // console.log("editor change!", quill, html, text);
      this.content = html;
    },
    onEditorChange1({ quill, html, text }) {
      // console.log("editor change!", quill, html, text);
      this.content = html;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/applications/applications-timeline-four.vue